import React from "react";
import { Redirect } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { LoadingView } from "@solsys/solsys-reactjs";

const myCranesQuery = gql`
  query customerHomeCranes($crane_list_request: crane_list_request) {
    crane(crane_list_request: $crane_list_request) {
      edges {
        id
      }
      totalCount
    }
  }
`;

// Customer landing: reads the customer's (server-scoped) cranes and jumps straight
// to the crane if they own exactly one, otherwise shows their scoped crane list.
export default function CustomerHome() {
  const { loading, error, data } = useQuery(myCranesQuery, {
    variables: { crane_list_request: { pagination: { limit: 2 } } },
    fetchPolicy: "network-only",
  });

  if (loading) return <LoadingView />;
  if (error) return <Redirect to="/ecrane/list" />;

  const edges = data?.crane?.edges ?? [];
  const total = data?.crane?.totalCount ?? edges.length;

  if (total === 1 && edges[0]?.id != null) {
    return <Redirect to={`/ecrane/edit/${edges[0].id}`} />;
  }
  return <Redirect to="/ecrane/list" />;
}
